import MaterialIcon from '@components/common/MaterialIcon';
import ButtonT from '@components/tailwind-components/Button/ButtonT';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import { ConversationReviewBulkActionsMenu } from './ConversationReviewBulkActionsMenu';

type Props = {
  isPreviousDisabled: boolean;
  isNextDisabled: boolean;
  isLastConversation: boolean;
  showBulkActions: boolean;
  isDisabled: boolean;
  onPrevious: () => void;
  onNext: () => void;
  onApproveAll: () => void;
  onMarkAllWrong: () => void;
  onSaveAndContinue: () => void;
};

export const ConversationReviewFooter: React.FC<Props> = ({
  isPreviousDisabled,
  isNextDisabled,
  isLastConversation,
  showBulkActions,
  isDisabled,
  onPrevious,
  onNext,
  onApproveAll,
  onMarkAllWrong,
  onSaveAndContinue,
}) => {
  const { t } = useTranslation();

  return (
    <div className='conversation-review-modal__footer'>
      <div className='conversation-review-modal__footer-nav'>
        <ButtonT
          type='button'
          styling='outline'
          size='xs'
          rounding='md'
          className='conversation-review-modal__nav-button'
          onClick={onPrevious}
          disabled={isPreviousDisabled || isDisabled}>
          <MaterialIcon icon='chevron_left' classes={['!text-sm']} />
          <span className='conversation-review-modal__nav-button-label'>
            {t('general.buttons.previous')}
          </span>
        </ButtonT>
        <ButtonT
          type='button'
          styling='outline'
          size='xs'
          rounding='md'
          className='conversation-review-modal__nav-button'
          onClick={onNext}
          disabled={isNextDisabled || isDisabled}>
          <span className='conversation-review-modal__nav-button-label'>
            {t('general.buttons.next')}
          </span>
          <MaterialIcon icon='chevron_right' classes={['!text-sm']} />
        </ButtonT>
      </div>
      <div className='conversation-review-modal__footer-actions'>
        {showBulkActions && (
          <ConversationReviewBulkActionsMenu
            disabled={isDisabled}
            onApproveAll={onApproveAll}
            onMarkAllWrong={onMarkAllWrong}
          />
        )}
        <ButtonT
          type='button'
          styling='primary'
          size='xs'
          rounding='md'
          disabled={isDisabled}
          onClick={onSaveAndContinue}>
          {isLastConversation
            ? t('train-ai.conversation-review.action.save-close')
            : t('train-ai.conversation-review.action.save-continue')}
        </ButtonT>
      </div>
    </div>
  );
};
